import { OS_CLM_RES_INIT_LOADING, OS_CLM_RES_INIT_SUCCESS, OS_CLM_RES_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

export const getters = {

}

export const mutations = {
  [OS_CLM_RES_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [OS_CLM_RES_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [OS_CLM_RES_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async osClmResInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.postOsClmRes
    commit(OS_CLM_RES_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(OS_CLM_RES_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(OS_CLM_RES_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
